import React, { Component } from 'react'
import styled from 'styled-components'
import Col from '../utils/StyledCol'
import Row from '../utils/StyledRow'
import WidgetContainer from '../containers/WidgetContainer'
import LinkHandler from '../utils/LinkHandler'
import Link from '../utils/Link'
import { MY_FINANCE_LINKS } from '../../constants'

const WrapperCol = Col.extend`
  display: flex;
  flex-wrap: wrap;
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  -ms-flex-pack: justify;
  -ms-flex-direction: row;
  justify-content: space-between;
  max-width: 100%;
`

const FinanceLink = styled(Link)`
  color: #333;
  display: block;
  font-size: 13px;
  letter-spacing: .1px;
  line-height: 18px;
  margin-bottom: 10px;
  text-decoration: none;
  width: 45%;
  max-width: 100%;
  overflow: hidden;
  & .image {
      background: url(${props => props.theme.myFinances.imageSource}) ${props => props.backgroundPosition} no-repeat;
      background-size: cover;
      display: block;
      float: left;
      margin-right: 10px;
      height: 26px;
      width: 30px;
  }
  & .text {
      margin-left: 40px;
  }
`

export default class MyFinance extends Component {
  renderLinks () {
    const {
      widget: {
        utmMedium,
        utmSource
      }
    } = this.props

    return MY_FINANCE_LINKS.map(link => {
      const utmParams = {
        utmSource,
        utmMedium,
        utmContent: link.utmContent
      }
      const location = new LinkHandler(link.location).mergeUTMParams(utmParams).link

      return (
        <FinanceLink href={location} key={link.text} backgroundPosition={link.backgroundPosition}>
          <span className='image'/>
          <div className='text'> {link.text} </div>
        </FinanceLink>
      )
    })
  }

  render () {
    const {
      widget
    } = this.props

    return (
      <WidgetContainer widget={widget}>
        <Row>
          <WrapperCol>
            { this.renderLinks() }
          </WrapperCol>
        </Row>
      </WidgetContainer>
    )
  }
}
